import logo from "../images/logo.png";

const PageLoader = () => {
  return (
    <div className="page-loader" role="status" aria-label="Loading">
      <img src={logo} alt="Play Mega Store" className="page-loader-logo" />
      <div className="page-loader-bar"><span></span></div>
    </div>
  );
};

export default PageLoader;
